import React, { FC } from "react";
import { connect } from "react-redux";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import default_image from "../../images/user-profile.svg";
import "./navbar.style.scss";
import { User } from "../../types/user";
import { UsersScore } from "../../types/UsersScore";

type Props = {
  user: User;
  score: UsersScore;
  setNavOpen: () => void;
};

const DropDown: FC<Props> = ({ user, score, setNavOpen }) => {
  const userScoreObj = score?.data?.filter((s) => s._id === user._id);
  const userScore = userScoreObj?.length > 0 ? userScoreObj[0].total : 0;
  return (
    <React.Fragment>
      <div className="user-info">
        <div className="user-img medium">
          {user?.img ? (
            <Avatar
              src={
                `${process.env.REACT_APP_CROQEE_SERVER_URL}/user-image/` +
                user?.img?.image_data
              }
              alt="profile image"
            />
          ) : (
            <Avatar src={default_image} alt="profile image" />
          )}
        </div>
        <div className="user-details">
          <ul>
            <li style={{ textTransform: "capitalize", fontSize: "18px" }}>
              {user?.name}
            </li>
            <li>{user?.email}</li>
            <li>score: {userScore}</li>
          </ul>
        </div>
      </div>
      <div className="profile-links">
        <ul>
          <li>
            <Link onClick={() => setNavOpen()} to={"/account/profile"}>
              View Profile
            </Link>
          </li>
          <li>
            <Link onClick={() => setNavOpen()} to="/account/password">
              Account Settings
            </Link>
          </li>
          <li>
            <Link onClick={() => setNavOpen()} to="/account/privacy">
              Privacy
            </Link>
          </li>
          <li>
            <Link onClick={() => setNavOpen()} to="/logout">
              Sign Out
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  user: state.user,
  score: state.usersScore,
});

export default connect(mapStateToProps)(DropDown);
